import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import {
  WARNING,
  CONFIRM,
  CANCEL,
  CLOSE_TOTE_WARNING,
  NOT_CONFIRMED_AT_DEPOT_PARCELS,
} from '../../../constants/strings';
import { Text } from '../../Base';
import warningTextModal from '../../styles/warningTextModal';
import { getRouteStops } from '../../../store/selectors/route';
import { checkNonCadsOnRoute } from '../../../models/parcel';

const useStyles = makeStyles(() => warningTextModal);

const CloseToteModal = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();

  const stops = useSelector(getRouteStops);

  const areAnyNonCads = checkNonCadsOnRoute(stops);

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={WARNING.toUpperCase()}
      actions={
        <>
          <Button
            minWidthZero
            onClick={onConfirm}
            className={classes.yellowButton}
          >
            {CONFIRM}
          </Button>
          <Button minWidthZero onClick={onClose} className={classes.blueButton}>
            {CANCEL}
          </Button>
        </>
      }
    >
      <Grid container direction="column">
        <Text className={classes.text}>{CLOSE_TOTE_WARNING}</Text>
        {areAnyNonCads && (
          <Text className={classes.text}>{NOT_CONFIRMED_AT_DEPOT_PARCELS}</Text>
        )}
      </Grid>
    </SimpleModal>
  );
};

export default memo(CloseToteModal);
